import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star, Quote } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white py-24 px-4" data-id="element-247">
      <div className="max-w-5xl mx-auto" data-id="element-248">
        {/* Origin Story */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-light rounded-[24px] border border-border p-8 md:p-12 mb-20 shadow-sm" data-id="element-249">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-250">
            <div data-id="element-251">
              <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-full mb-6" data-id="element-252">
                <Heart className="w-6 h-6 text-primary" data-id="element-253" />
              </div>
              <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline mb-6" data-id="element-254">
                Por qué creé este sistema
              </h2>
              <div className="space-y-4 text-lg text-body leading-relaxed" data-id="element-255">
                <p data-id="element-256">
                  Sé lo difícil que es querer aportar económicamente en casa sin
                  tener que dejar a tus hijos al cuidado de extraños.
                </p>
                <p data-id="element-257">
                  Veía a tantas mamás latinas frustradas, intentando negocios
                  complicados o trabajando jornadas agotadoras, mientras la
                  Inteligencia Artificial avanzaba a pasos agigantados.
                </p>
                <p className="font-medium text-dark" data-id="element-258">
                  Decidí democratizar estas herramientas. Quería crear un puente
                  entre la tecnología avanzada y las mamás reales que necesitan
                  soluciones prácticas, rápidas y que funcionen desde un
                  celular.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-[20px] p-8 border border-border shadow-lg relative" data-id="element-259">
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-cta/10 rounded-full blur-xl" data-id="element-260"></div>
              <h3 className="text-2xl text-dark font-display font-bold mb-6" data-id="element-261">
                Hecho para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-262">
                {['Eres mamá y tu tiempo es limitado', 'Vives en USA y sientes el peso de la inflación', 'No quieres aparecer en cámara ni bailar en TikTok', 'No tienes experiencia previa en tecnología o ventas', 'Quieres una fuente de ingresos extra desde tu celular'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-263">
                    <div className="mt-1 bg-primary/10 p-1 rounded-full flex-shrink-0" data-id="element-264">
                      <Star className="w-4 h-4 text-primary fill-primary" data-id="element-265" />
                    </div>
                    <span className="text-body font-medium" data-id="element-266">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Beta Testimonials Placeholder Structure */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-267">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-268">
            Resultados Reales
          </span>
          <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline" data-id="element-269">
            Lo que dicen nuestras alumnas beta
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-270">
          {[{
          name: 'María G.',
          role: 'Mamá de 2',
          quote: 'Nunca pensé que la IA fuera tan fácil de usar. En un fin de semana ya tenía mi guía lista para vender.'
        }, {
          name: 'Carmen R.',
          role: 'Trabaja full-time',
          quote: 'Lo hice todo desde mi iPhone mientras esperaba en el auto a que salieran mis hijos de la escuela.'
        }, {
          name: 'Elena S.',
          role: 'Emprendedora',
          quote: 'Los scripts de WhatsApp valen oro. Por fin sé qué responder cuando me preguntan "info".'
        }].map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-light rounded-[20px] p-8 border border-border relative" data-id="element-271">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-primary/10" data-id="element-272" />
              <div className="flex text-yellow-400 mb-4" data-id="element-273">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-274" />)}
              </div>
              <p className="text-body italic mb-6 relative z-10" data-id="element-275">
                "{testimonial.quote}"
              </p>
              <div data-id="element-276">
                <p className="font-bold text-dark" data-id="element-277">{testimonial.name}</p>
                <p className="text-sm text-slate-500" data-id="element-278">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}